import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import '../css/table.css'
import ascendIcon from '../images/ascendingIcon.svg'
import descendIcon from '../images/descendingIcon.svg'
import deleteIcon from '../images/deleteIcon.svg'
import editIcon from '../images/editIcon.svg'
import FadeLoader from './FadeLoader'
import _ from 'lodash'
import { Redirect } from 'react-router-dom'
import Modal from 'react-responsive-modal'
import {
  removeDocument,
  getRelatedListType
} from '../utils/pouchdb'
import async from 'async'
import { Logger } from "react-remote-logger"

moment.locale('fr')

class DataTable extends Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.state = {
      org: props.org,
      groupName: props.groupName,
      listTypeContent: null,
      editIsClicked: false,
      typeId: null,
      openModal: false,
      selectedId: null,
      numberOfrelatedDocument: 0,
      relatedDocuments: null,
      valueKey: '',
      isSorted: false
    }
  }

  componentDidMount () {
    this._isMounted = true
    if (this._isMounted) {
      var listTypeContent = this.props.listTypeContent
      if (listTypeContent.length > 0 && !listTypeContent[0].hasOwnProperty("name")) {
        listTypeContent = listTypeContent.map((e) => {
          return Object.assign({name: e.label}, e)
        })
      }
      this.setState({
        listTypeContent: listTypeContent
      })
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.listTypeContent !== this.props.listTypeContent || nextProps.groupName !== this.props.groupName) {
      var listTypeContent = nextProps.listTypeContent
      this.setState({
        org: nextProps.org,
        listTypeContent: listTypeContent,
        groupName: nextProps.groupName
      })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  onOpenModal (id, type, name) {
    const self = this
    var org = self.state.org
    getRelatedListType(org, type, name).then(function (result) {
      self.setState({
        openModal: true,
        selectedId: id,
        numberOfrelatedDocument: result.docs.length,
        relatedDocuments: result.docs
      })
    })
  }

  onCloseModal () {
    var self = this
    self.setState({
      openModal: false,
      numberOfrelatedDocument: 0,
      relatedDocuments: null
    })
  }

  deleteType (id) {
    var self = this
    var org = self.state.org
    var urlString = window.location.href
    var urlArray = urlString.split('/')
    localStorage.setItem('currentRoute', urlArray[urlArray.length - 1])
    var relatedDocuments = self.state.relatedDocuments
    if (relatedDocuments.length > 0) {
      async.eachLimit(relatedDocuments, 1, function (document, callback) {
        removeDocument(org, document._id).then(function (result) {
          Logger({
            'timestamp': (new Date()).toLocaleString(),
            'level': 'debug',
            'user_id': localStorage.user_id,
            'user': localStorage.user_email,
            'organization': localStorage.organization,
            'action': 'DELETE',
            'id': document._id,
            'url': window.location.href,
            'message': `DELETE ${window.location.href}`
          })
          callback()
        }).catch(function (err) {
          console.log(err)
          callback()
        })
      }, function (err) {
        if (err) {
          console.log(err)
        } else {
          removeDocument(org, id).then(function (result) {
            console.log('Documents deleted Successfully')
            Logger({
              'timestamp': (new Date()).toLocaleString(),
              'level': 'debug',
              'user_id': localStorage.user_id,
              'user': localStorage.user_email,
              'organization': localStorage.organization,
              'action': 'DELETE',
              'id': id,
              'url': window.location.href,
              'message': `DELETE ${window.location.href}`
            })
            self.onCloseModal()
            self.props.reloadComponent()
          })
        }
      })
    } else {
      removeDocument(org, id).then(function (result) {
        console.log(result)
        Logger({
          'timestamp': (new Date()).toLocaleString(),
          'level': 'debug',
          'user_id': localStorage.user_id,
          'user': localStorage.user_email,
          'organization': localStorage.organization,
          'action': 'DELETE',
          'id': id,
          'url': window.location.href,
          'message': `DELETE ${window.location.href}`
        })
        self.onCloseModal()
        self.props.reloadComponent()
      })
    }
  }

  sortByColumn (key) {
    const self = this
    const columnState = !this.state[key]
    this.setState({
      isSorted: true,
      [key]: columnState,
      listTypeContent: _.orderBy(
        self.state.listTypeContent,
        [data => data[key].toString().toLowerCase()],
        columnState ? 'asc' : 'desc'
      ),
      valueKey: key
    })
  }

  render () {
    if (this.state.listTypeContent && !this.state.editIsClicked) {
      var listTypeContent = _.map(this.state.listTypeContent, function (elem) {
        if (!elem?.name) {
          elem.name = elem.label
        }
        return elem
      })
      if (!this.state.isSorted) {
        listTypeContent = _.orderBy(
          listTypeContent, [data => data.name.toString().toLowerCase()
          ], 'desc'
        )
      }
      return (
        <div style={styles.content}>
          <table cellSpacing='0' className='table'>
            <thead>
              <tr className='head'>
                <td
                  className='td-left-padding td-left-padding-standard td-left head-border td-outline'
                  role='gridcell'
                  onClick={
                    () => this.sortByColumn('name')
                  }
                  tabIndex={0}
                  onKeyPress={() => {}}
                >
                  <span>{this.state.groupName}</span>
                  {
                    this.state.valueKey === 'name'
                      ? (this.state.name === true
                        ? <img
                          style={styles.icon}
                          src={ascendIcon}
                          alt='true'
                        />
                        : <img
                          style={styles.icon}
                          src={descendIcon}
                          alt='true'
                        />)
                      : <img
                        style={styles.icon}
                        src={descendIcon}
                        alt='true'
                      />
                  }
                </td>
                <td className='td-head-right-standard head-border'>
                  <span style={styles.sum}>Total: {this.props.listTypeContentLength}</span>
                </td>
              </tr>
            </thead>
            <tbody>
              {listTypeContent.map((value) =>
                <tr key={value._id} className='tr'>
                  <td className='td td-left-padding-standard td-left td-center'>
                    {value.name}
                  </td>
                  <td className='td td-right-standard hover-button'>
                    <div style={styles.contentButton}>
                      <div className='hover-button--off' />
                      <div className='hover-button--on'>
                        <table cellSpacing='0' style={styles.table}>
                          <tbody>
                            <tr>
                              <td style={styles.iconContent}>
                                <div
                                  style={{ outline: 'none' }}
                                  tabIndex={value._id}
                                  onClick={() => this.onOpenModal(value._id, value.type, value.name)}
                                  role='button'
                                  onKeyPress={() => {}}
                                >
                                  <img
                                    style={styles.iconHover}
                                    src={deleteIcon}
                                    alt='true'
                                  />
                                </div>
                              </td>
                              <td style={styles.iconContent}>
                                <div
                                  style={{ outline: 'none' }}
                                  tabIndex='0'
                                  onClick={() => this.setState({
                                    editIsClicked: true,
                                    typeId: value._id
                                  })}
                                  role='button'
                                  onKeyPress={() => {}}
                                >
                                  <img
                                    src={editIcon}
                                    style={styles.iconHover}
                                    alt='true'
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div>
            <Modal
              styles={bg}
              open={this.state.openModal}
              onClose={() => this.onCloseModal()}
              showCloseIcon={false}
              center
              focusTrapped={false}
            >
              {this.state.numberOfrelatedDocument > 0
                ? (
                  <h2 style={styles.modalTitle}>Suppression de références </h2>
                )
                : (
                  <h2 style={styles.modalTitle}>Suppression de référence </h2>
                )}
              {this.state.numberOfrelatedDocument > 0
                ? (
                  <p style={styles.modalText}>
                    Voulez vous  vraiment supprimer cette référence et aussi ses références liées ?
                  </p>
                )
                : (
                  <p style={styles.modalText}>
                    Voulez vous  vraiment supprimer cette référence ?
                  </p>
                )}
              <div>
                <button style={styles.modalButtonLeft} onClick={() => this.onCloseModal()}><span>Annuler</span></button>
                <button style={styles.modalButtonRight} onClick={() => this.deleteType(this.state.selectedId)}>Supprimer</button>
              </div>
            </Modal>
          </div>
        </div>
      )
    }
    if (this.state.editIsClicked) {
      localStorage.setItem('organization', this.state.org)
      localStorage.setItem('dataGroupId', this.props.groupId)
      return <Redirect
        to={{
          pathname: `/${this.state.org}/add-data`,
          state: {
            groupName: this.props.groupName,
            groupId: this.props.groupId,
            groupType: 'data',
            editedTypeId: this.state.typeId
          }
        }}
      />
    }
    return <FadeLoader />
  }
}

const bg = {
  modal: {
    background: '#EBEBEB',
    borderRadius: '6px',
    color: '#272D31'
  }
}

const styles = {
  content: {
    paddingTop: 14,
    width: '100%'
  },
  contentButton: {
    width: 120,
    float: 'right'
  },
  sum: {
    float: 'right',
    color: '#DA262E',
    fontWeight: 800,
    paddingRight: 22,
    fontSize: 18
  },
  icon: {
    float: 'right',
    marginTop: 6,
    marginRight: 4,
    marginLeft: 12
  },
  iconRigth: {
    float: 'right',
    marginTop: 6,
    marginLeft: 12
  },
  table: {
    float: 'right'
  },
  iconContent: {
    paddingLeft: 6
  },
  iconHover: {
    cursor: 'pointer'
  },
  modalTitle: {
    fontSize: 14,
    marginTop: '-10px',
    textAlign: 'center'
  },
  modalText: {
    fontSize: '12px'
  },
  modalButtonLeft: {
    float: 'left',
    width: '100px',
    borderWidth: '0px',
    height: '24px',
    borderRadius: '3px',
    outline: 'none'
  },
  modalButtonRight: {
    backgroundColor: '#DA262E',
    borderWidth: '0px',
    float: 'right',
    width: '100px',
    height: '24px',
    borderRadius: '3px',
    outline: 'none'
  }
}

DataTable.propTypes = {
  groupName: PropTypes.string,
  groupId: PropTypes.string,
  listTypeContent: PropTypes.array,
  org: PropTypes.string,
  listTypeContentLength: PropTypes.number
}

export default DataTable
